/*
 * @Author: 吴文洁
 * @Date: 2020-10-22 17:50:54
 * @LastEditors: renmanyi
 * @LastEditTime: 2023-05-26 14:38:03
 * @Description: 
 * @Copyright: 杭州杰竞科技有限公司 版权所有
 */
// 库存数量格式化
export function formatStock(number) {
  if (number < 0) {
    return 0;
  }
  return number;
}

export function formatDate(timestamp, format) {
  if (!timestamp) {
    return '';
  }
  const date = new Date(Number.parseInt(timestamp, 10));
  const y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  let h = date.getHours();
  let i = date.getMinutes();
  let s = date.getSeconds();
  const w = date.getDay();
  const week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  const newWeek = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

  m = m < 10 ? '0' + m : m;
  d = d < 10 ? '0' + d : d;
  h = h < 10 ? '0' + h : h;
  i = i < 10 ? '0' + i : i;
  s = s < 10 ? '0' + s : s;

  return format.replace('YYYY', y)
    .replace('MM', m)
    .replace('DD', d)
    .replace('H', h)
    .replace('i', i)
    .replace('s', s)
    .replace('ww', newWeek[w])
    .replace('WW', week[w]);
}

export function formatMinute(tempminute) {
  let hour = Math.floor(tempminute / 60);
  let minute = tempminute % 60;
  if (hour < 10) {
    hour = '0' + hour;
  }
  if (minute < 10) {
    minute = '0' + minute;
  }
  return (hour + ':' + minute);
}

export function timeConversion(time) {
  // console.log(time)
  //time是传进来的分钟数
  let timeData = '';
  let h = Math.floor(time / 60);
  time -= h * 60;
  if (time == 0) {
    if (h < 10) {
      timeData = h ? '0' + h + ':00' : '00:00';
    } else {
      timeData = h ? h + ':00' : '';
    }
  } else {
    if (time < 10) {
      time = '0' + time;
    }
    if (h < 10) {
      h = '0' + h;
    }
    timeData = (h ? h + ':' : '00:') + (time ? time + '' : '00');
  }
  return timeData;
}


export function timeFormat(time, defaultValue = 0) {
  const stringTime = time ? (time / window.CONFIG.timeUnit).toFixed(2) : defaultValue;
  return Number(stringTime);
}

export function moneyFormat(money, defaultValue = 0, isString) {
  const stringMoney = money ? (money / window.CONFIG.moneyUnit).toFixed(2) : defaultValue;
  if (isString) {
    return (stringMoney + '').replace(/\d(?=((\d{3})+)\.\d{2}$)/g, item => item + ',');
  } else {
    return Number(stringMoney);
  }
}

// 将数字的整数部分按照三位数一组逗号分隔，同时支持取几位小数，默认取整
export function moneyFormatGroup(money = 0, fixed = 0) {
  const fixedMoney = money.toFixed(fixed);

  return fixedMoney.replace(/\d(?=((\d{3})+)((?=\.)|$))/g, item => item + ',');
}

export function toFixed(money, digit) { 
  return money.toFixed(digit);
}

export function formatMsgCreateTime(createTime) {
  return window.formatMsgCreateTime(createTime);
}

export function oppenent(money, defaultValue) {
  return 0 - Number(money);
}

export function signStatus(status) {
  return window.ENUM.SignType[status];
}

export function desc(value, field) {
  const descs = window.ENUM[field];
  return descs && descs[value] || '';
}

export function timeToDates(value) {
  const date = Math.floor(value / 24 / 60 / 60 / 1000);
  return date;
}

export function formatContent(value) {
  const regRN = /[↵]/g;
  return value.replace(regRN, '<br/>');
}

export function overStep(value, overLimit, type) {
  if (type === 'add') {
    return value > overLimit ? overLimit : value;
  }
  return value < overLimit ? overLimit : value;
}

export function getCostWayName(data) {
  switch (data.consumptionType) {
    case 'ACCOUNT_BALANCE':
      return `充值账户【${data.userPhone}】`;
    case 'COURSE':
      return `课程【${data.courseName}】`;
    case 'EXPERIENCE_CARD':
      return `体验卡【${data.cardHistoryInfo.title}】`;
    case 'MEMBER_CARD':
      return `会员卡【${data.memberCardTitle}】`;
    default:
      return '';
  }
}



// WEBPACK FOOTER //
// ./src/core/filters.js